import React, { useEffect, useState } from 'react';
import IndustryExpertise from '../IndustryExpertise';

const IndustryExpertiseThread = ({ thread }) => {
  const { data = {}, name = '', id = '' } = thread;

  const [formData, setFormData] = useState({
    industry: data.industry || '',
    geography: data.geography || '',
    size: data.size || '',
  });

  const [chatHistory, setChatHistory] = useState(data.chat || []);
  const [intelResult, setIntelResult] = useState(data.industryIntelResult || '');

  // 🔁 Reset local state when thread ID changes
  useEffect(() => {
    setFormData({
      industry: data.industry || '',
      geography: data.geography || '',
      size: data.size || '',
    });
    setChatHistory(data.chat || []);
    setIntelResult(data.industryIntelResult || '');
  }, [id]);

 return (
    <IndustryExpertise
      key={id} // ✅ THIS forces the form to remount when thread changes
      existingFormData={formData}
      existingChatHistory={chatHistory}
      existingThreadName={name}
      existingThreadId={id}
      industryIntelResult={intelResult}
      scrollToOutputOnMount={false}
    />
  );
};

export default IndustryExpertiseThread;

